angular.module('logbook')
.directive('chartAxisControls', [ 
function() {
  return {
    redirect: 'E',

    scope: {
       'selectedAxis': '=',
       'computedAxis': '=',
       'unitDefaultAxis': '=',
       'units': '=',
       'setAxis': '&'
    },

    template: require('./chart-axis-controls.html'),

    link: function(scope, elem, attrs) {
       console.log('asd');
    }
  }
}]);
